import { useLang } from "@/i18n/LanguageContext";

export const Marquee = () => {
  const { t } = useLang();
  const items = t("marquee.items");

  return (
    <div data-testid="editorial-marquee" className="relative bg-slate-100 border-y border-slate-200 py-5 overflow-hidden">
      <div className="marquee-track flex w-max items-center">
        {[0, 1].map((copy) => (
          <div key={copy} className="flex items-center shrink-0" aria-hidden={copy === 1}>
            {items.map((item) => (
              <span key={`${copy}-${item}`} className="flex items-center">
                <span className="font-mono text-sm sm:text-base font-bold tracking-[0.18em] text-slate-500 px-8 whitespace-nowrap">
                  {item}
                </span>
                <span className="w-2 h-2 rounded-full bg-blue-600 photon-dot" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
